import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const STORAGE_ACCESS = "clockin.access";
const STORAGE_REFRESH = "clockin.refresh";
const STORAGE_USER = "clockin.user";

export function getAccessToken() {
  return localStorage.getItem(STORAGE_ACCESS);
}
export function getRefreshToken() {
  return localStorage.getItem(STORAGE_REFRESH);
}
export function setSession({ access_token, refresh_token, user }) {
  if (access_token) localStorage.setItem(STORAGE_ACCESS, access_token);
  if (refresh_token) localStorage.setItem(STORAGE_REFRESH, refresh_token);
  if (user) localStorage.setItem(STORAGE_USER, JSON.stringify(user));
}
export function clearSession() {
  localStorage.removeItem(STORAGE_ACCESS);
  localStorage.removeItem(STORAGE_REFRESH);
  localStorage.removeItem(STORAGE_USER);
}
export function loadStoredUser() {
  const raw = localStorage.getItem(STORAGE_USER);
  return raw ? JSON.parse(raw) : null;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshInFlight = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !original._retry &&
      getRefreshToken() &&
      !original.url.includes("/auth/refresh") &&
      !original.url.includes("/auth/login")
    ) {
      original._retry = true;
      try {
        if (!refreshInFlight) {
          refreshInFlight = axios.post(`${API}/auth/refresh`, {
            refresh_token: getRefreshToken(),
          });
        }
        const { data } = await refreshInFlight;
        refreshInFlight = null;
        setSession(data);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshInFlight = null;
        clearSession();
        if (typeof window !== "undefined") window.location.href = "/login";
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Request failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(", ");
  return String(detail);
}
